import React, { useState, useEffect, useRef } from "react";
import "./Header.css";
import avatar from "../../assets/images/author.jpg";
import { loginsuccess } from "../../../config/data";
import DropdownProfile from "./Dropdown/DropdownProfile";
import { Link, useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import DarkModeToggle from "../../Common/DarkModeToggle/DarkModeToggle";

export const Header = () => {
  const [visibleDetails, setVisibleDetails] = useState(false);
  const [displayName, setDisplayName] = useState(localStorage.getItem("displayName"));
  const ref = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    const handleStorageChange = () => {
      setDisplayName(localStorage.getItem("displayName"));
    };

    window.addEventListener("storage", handleStorageChange);

    return () => window.removeEventListener("storage", handleStorageChange);
  }, []);

  const handleClick = () => {
    setVisibleDetails(!visibleDetails);
  };

  const handleCreateClick = () => {
    const idToken = localStorage.getItem("idToken");
    if (!idToken) {
      toast.error("Please login to create stories");
      navigate('/login');
      return;
    }
    navigate('/create');
  };

  return (
    <div>
      <nav className="main-nav">
        <div className="logo">
          <h2>
            <Link to="/">
              <span className="logo-large">S</span>tory
              <span className="logo-large">B</span>uddy
            </Link>
          </h2>
        </div>

        <div className="header-buttons">
            <button className="storybuddy-btn alternative" onClick={() => navigate('/')}>
              Discover
            </button>
            <button className="storybuddy-btn alternative" onClick={handleCreateClick}>
              Create
            </button>
            <button className="storybuddy-btn alternative" onClick={() => navigate('/knowledge')}>
              Learn
            </button>
        </div>
        <ToastContainer />
        <DarkModeToggle />

        {loginsuccess.value === 1 ? (
          <div className="login-button">
            <Link to="/Login" className="logina">Login</Link>
          </div>
        ) : (
          <div className="logininfo">
            <div className="loginuser">
              <p>Welcome {displayName ? displayName : "Guest"}!</p>
            </div>
            <img
              src={avatar}
              className="user_image"
              alt="User Avatar"
              onClick={handleClick}
            />
            {visibleDetails ? <DropdownProfile /> : null}
          </div>
        )}
      </nav>
    </div>
  );
};
